import React, { useState } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { Box } from '@mui/material';
import { WhatsAppProvider, useWhatsApp } from '../context/WhatsAppContext';
import Navbar from './Navbar';
import Sidebar from './Sidebar';
import StatusViewer from './StatusViewer';
import StatusPoster from './StatusPoster';

import Dashboard from '../pages/Dashboard';
import GenerateQR from '../pages/GenerateQR';
import Reports from '../pages/Reports';
import ChatPage from '../pages/ChatPage';
import SendMessage from '../pages/SendMessage';
import WhatsAppGroup from '../pages/WhatsAppGroup';
import APIDocs from '../pages/APIDocs';

const AppLayout = () => {
  const location = useLocation();
  const showSidebar = location.pathname === '/chat';
  const [mobileSidebarOpen, setMobileSidebarOpen] = useState(false);
  const [viewingStatus, setViewingStatus] = useState(null);
  const [showPoster, setShowPoster] = useState(false);

  const { postStatus } = useWhatsApp();

  const handleStatusClick = (statusId) => setViewingStatus(statusId);
  const handleCloseStatus = () => setViewingStatus(null);

  const handlePostStatus = async (formData) => {
    await postStatus(formData);
    setShowPoster(false);
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: '100vh', overflow: 'hidden' }}>
      <Navbar />

      {/* Mobile sidebar toggle */}
      {showSidebar && (
        <button
          className="md:hidden fixed top-4 left-4 z-40 p-2 bg-white rounded-full shadow-lg"
          onClick={() => setMobileSidebarOpen(true)}
          aria-label="Open sidebar"
        >
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <line x1="3" y1="6" x2="21" y2="6" />
            <line x1="3" y1="12" x2="21" y2="12" />
            <line x1="3" y1="18" x2="21" y2="18" />
          </svg>
        </button>
      )}

      {showSidebar && (
        <Sidebar
          isMobileOpen={mobileSidebarOpen}
          onMobileClose={() => setMobileSidebarOpen(false)}
          onStatusClick={handleStatusClick}
          onPostStatus={() => setShowPoster(true)}
        />
      )}

      <Box
        component="main"
        sx={{
          flexGrow: 1,
          ml: { xs: 0, md: showSidebar ? '350px' : 0 },
          mt: '64px',
          height: showSidebar ? 'calc(100vh - 64px)' : 'auto',
          overflow: showSidebar ? 'hidden' : 'auto',
          p: showSidebar ? 0 : 3,
          bgcolor: '#f8f9fa',
        }}
      >
        <Routes>
          <Route path="/" element={<Dashboard />} />
          <Route path="/chat" element={<ChatPage />} />
          <Route path="/generate-qr" element={<GenerateQR />} />
          <Route path="/reports" element={<Reports />} />
          <Route path="/send-message" element={<SendMessage />} />
          <Route path="/groups" element={<WhatsAppGroup />} />
          <Route path="/api-docs" element={<APIDocs />} />
        </Routes>
      </Box>

      {viewingStatus && (
        <StatusViewer statusId={viewingStatus} onClose={handleCloseStatus} />
      )}

      {showPoster && (
        <StatusPoster
          onClose={() => setShowPoster(false)}
          onPost={handlePostStatus}
        />
      )}
    </Box>
  );
};

const WhatsAppApp = () => (
  <BrowserRouter>
    <WhatsAppProvider>
      <AppLayout />
    </WhatsAppProvider>
  </BrowserRouter>
);

export default WhatsAppApp;
